import * as React from 'react';
import {useState, useEffect, useRef} from "react";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {useSelector} from 'react-redux';
import {
  Divider,
  IconButton,
  Select,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  scopedCssBaselineClasses
} from '@mui/material';
import {findCode, printVariable} from '@util/helper';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import {useMediaQuery} from "@mui/material";
import WebService from '@util/webService';
import useSnackbar from '@hooks/useSnackbar';
import useIndicator from '@hooks/useIndicator';
import axios from 'axios';
import {Fragment} from 'react';
import moment from 'moment';
import MUITable from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import TableFooter from "@mui/material/TableFooter"
import MyTableHead from '@components/MyTableHead';
import ConfirmDialog from "@components/ConfirmDialog";
import useAlert from "@hooks/useAlert";
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import Box from "@mui/material/Box";
import {GlobalStyle as gs} from "@src/GlobalStyle"
import '@scss/App.scss'
import { useTheme } from '@mui/material/styles';
import consoleLogger from 'react-terminal-logger/console-logger';
const ManagerAttdncPartBing = ({record, dialogHandler, callback}) => {
  console.log('record=>', record)
  const [openSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const {alert, renderAlert} = useAlert()
  const [dataList, set_dataList] = React.useState([])
  const [dateTime, set_dateTime] = React.useState({})
  const [attdnc, set_attdnc] = React.useState({})
  const lschsRef = useRef()
  // redux
  const codes = useSelector(state => state.codeReducer);
  const account = useSelector(state => state.accountReducer);
  const schola = useSelector(state => state.scholaReducer);
  const dateFormat = 'YYYY-MM-DD HH:mm:ss';

  const statCodes = codes.filter(r => r.codeGroupId === 'SA10')

  console.log('statCodes=>', statCodes)
  const recordRef = useRef(null)
  const statCodeRef = useRef(null)
  const buttonRef = useRef(null)
  const fields = [
    {field: 'id', placeholder: '', type: 'text', value: -1, visible: false, canSrch: false, selList: []},
    {field: 'indexing', placeholder: 'No.', type: 'text', value: '', visible: true, canSrch: false, selList: []},
    {field: 'schoolId', placeholder: '학교명', type: 'auto', value: '', visible: false, canSrch: true, selList: []},
    {field: 'grade', placeholder: '학년', type: 'number', value: '', visible: true, canSrch: true, selList: []},
    {field: 'className', placeholder: '반', type: 'text', value: '', visible: true, canSrch: true, selList: []},
    {field: 'classNum', placeholder: '번호', type: 'number', value: '', visible: true, canSrch: false, selList: []},
    {field: 'name', placeholder: '이름', type: 'text', value: '', visible: true, canSrch: false, selList: []},
    {field: 'gdnPhone', placeholder: '보호자 전화 번호', type: 'number', value: '', visible: true, canSrch: false, selList: []},
    {field: 'offCodeName', placeholder: '귀가방법', type: 'text', value: '', visible: true, canSrch: false, selList: []},
    {field: 'statName', placeholder: '출결상태', type: 'number', value: '', visible: true, canSrch: false, selList: []},
    {field: 'startmYn', placeholder: '시작알림', type: 'number', value: '', visible: true, canSrch: false, selList: []},
    {field: 'endmYn', placeholder: '종료알림', type: 'number', value: '', visible: true, canSrch: false, selList: []},
  ]

  const weekCode = {'1': '월', '2': '화', '3': '수', '4': '목', '5':'금', '6':'토', '7':'일'}

  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") {
      return
    } else {
      dialogHandler[1](false)
    }
  }

  const parseData = (report, lschs) => {
    const students = report.students
    const bings = report.bings
    const regis = report.regis

    console.log('parseData regis=>', regis)
    if(!report.attdnc) {
      alert('데이터가 없습니다.')
      return
    }

    for(const [idx, student] of students.entries()) {
      
      student.statCode = bings[idx].statCode
      student.statName = findCode(codes, 'SA10', bings[idx].statCode)?.name ?? ''
      student.startmYn = bings.find(b => b.studentId === student.id)?.startmYn ?? ''
      student.endmYn = bings.find(b => b.studentId === student.id)?.endmYn ?? ''
      student.userYn = bings.find(b => b.studentId === student.id)?.userYn ?? ''
      student.bingId = bings.find(b => b.studentId === student.id)?.id ?? ''

      student.offCode = regis.find(r => r.studentId == student.id)?.offCode ?? ''
      student.offCodeName = findCode(codes, 'SA29', student.offCode)?.name ?? ''

    }
    // students.sort((a,b) => a.name.localeCompare(b.name))
   
    students.forEach(s => console.log('s=>', s))

    if(report.attdnc) {
      const attdnc = report.attdnc
      const dt = moment(attdnc.lectureTime, dateFormat)
      const idx = lschs.findIndex(r => r.id === attdnc.lschId)

      const subDt = moment(attdnc.subLectureTime, dateFormat)
      const subDay = weekCode[''+subDt.day()]
      const subStartTime = moment(attdnc.subStartTime, 'HH:mm')
      const subEndTime = moment(attdnc.subEndTime, 'HH:mm')

      console.log('subDay=>', subDay)
      if(idx >= 0) {
        const startTime = lschs[idx].startTime
        const endTime = lschs[idx].endTime

        const dateTime = {
          date: dt.format('YYYY-MM-DD'),
          day: weekCode[''+dt.day()],
          startTime: startTime,
          endTime: endTime,

          subDate: subDt.format('YYYY-MM-DD'),
          subDay: subDay,
          subStartTime: subStartTime.format('HH:mm'),
          subEndTime: subEndTime.format('HH:mm'),

        }
        set_dateTime(dateTime)
        set_attdnc(attdnc)
      }
      set_dataList(students)
    }

  }

  const onLoad = async () => {
    openIndicator()
    const report = await fetchBings()
    const lschs = await fetchLschs()
    lschsRef.current = lschs

    parseData(report, lschsRef.current)

    closeIndicator()
  }


  const fetchBings = async (attdncId, direction) => {
    openIndicator()
    const url = `/attdnc/single/lecture/${record.id}`
    const params = {attdncId: attdncId, direction: direction}
    const resp = await WebService.get(url, params)
    closeIndicator()
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const respMessage = JSON.parse(resp.repMessage)
    return JSON.parse(respMessage.report)
  }

  const fetchForward = async () => {
    const report = await fetchBings(attdnc?.id, 'forward')
    parseData(report, lschsRef.current)
  }

  const fetchBackward = async () => {
    const report = await fetchBings(attdnc?.id, 'backward')
    parseData(report, lschsRef.current)
  }

  const fetchLschs = async () => {
    const url = `/lsch/lecture/${record.id}`
    const resp = await WebService.get(url)
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const respMessage = JSON.parse(resp.repMessage)
    return JSON.parse(respMessage.records)
  }

  const handleChange = async() => {
    if(recordRef.current == null || statCodeRef.current == null)  {
      return
    }

    const url = '/bing/update'
    const params = {
      id: recordRef.current.bingId,
      statCode: statCodeRef.current
    }
    openIndicator()
    const resp = await WebService.post(url, {}, params)
    closeIndicator()

    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const newDataList = [...dataList]
    const found = newDataList.find(r => r.bingId === recordRef.current.bingId)
    if(found) {
      found.statCode = statCodeRef.current
      set_dataList(newDataList)
    }
    
  }

  React.useEffect(() => {
    if (dialogHandler[0]) {
      onLoad()
    }
  }, [dialogHandler[0]])


  return (
    <Fragment>
      <ConfirmDialog
          btn={<Button ref={buttonRef} color={'error'} style={{display:'none'}}></Button>}
          title={'주의'}
          content={'출결상태를 변경하시겠습니까?'}
          bc={'primary'}
          preHandle={ async () => {
            return true
          }}
          perform={() => {
            handleChange()
          }}
      />  
      <Dialog open={dialogHandler[0]} onClose={handleClose} maxWidth='lg' fullWidth>
        <DialogTitle>
          {/*<Box sx={{display:'center', justifyContent:'center', alignItems:'center'}}>*/}
          <Box className={'center'}>
            <Typography variant='h5' sx={{fontWeight:'bold'}} align='center'>
              {record.title}
            </Typography>
            <Typography variant='h5' sx={{margin:1}}> 출석부</Typography>
          </Box>

          <Divider></Divider>
        </DialogTitle>
        <DialogContent sx={{minHeight:'50vh'}}>
          <Box sx={{display:'flex', alignItems:'center', justifyContent:'center', margin:1}}>
            <Typography style={{textDecoration: dateTime.subDay ? 'line-through' : null}}>
              {dateTime.date}, {dateTime.day}, {dateTime.startTime} ~ {dateTime.endTime}
            </Typography>
            {
              dateTime.subDay ? (
                <Typography style={{marginLeft:10,}}>
                   --&gt; {dateTime.subDate}, {dateTime.subDay}, {dateTime.subStartTime} ~ {dateTime.subEndTime}
                </Typography>
              ) : null
            }
            <Typography>
              
            </Typography>
          </Box>

          <div style={{display:'flex', flex:1, alignItems:'center', 
            margin:1, justifyContent:'space-evenly', flexDirection:'row', marginBottom:10,
            backgroundColor: (attdnc.userYn === 'Y' && attdnc.startmYn === 'Y' && attdnc.endmYn === 'Y') ?  gs.colors.attdncGood: gs.colors.attdncBad
            }}
          >
            <Typography>
              출석부 저장 {attdnc.userYn === 'Y' ? 'Y' : 'N'}
            </Typography>
            <Typography>
              시작알림 {attdnc.startmYn === 'Y' ? 'Y' : 'N'}
            </Typography>
            <Typography>
              종료알림 {attdnc.endmYn === 'Y' ? 'Y' : 'N'}
            </Typography>
          </div>

          <MUITable>
            <MyTableHead>
              <TableRow>
                {
                  fields.map((col, index) => (
                    col.visible ? (
                      <TableCell size='small' key={index} >
                        {col.placeholder}
                      </TableCell>
                    ) : null
                  ))
                }
              </TableRow>
            </MyTableHead>
            <TableBody>
              {
                dataList && dataList.map((row, rowIdx) => {
                  return (
                    <TableRow key={rowIdx} style={{backgroundColor: row.statCode.startsWith('X') ? '#ffebee' : null }}>
                      {

                        fields.map((col, colIdx) => (
                          col.visible ? (
                            col.field === 'indexing' ? (
                              <TableCell size='small'>{rowIdx + 1}</TableCell>
                            ) : col.field === 'statName' ? (
                                <TableCell size='small'>
                                   <FormControl fullWidth>
                                    <InputLabel id='statCode'>
                                      상태 
                                    </InputLabel>
                                    <Select
                                      labelId='statCode'
                                      required
                                      label='상태'
                                      name={"statCode"}
                                      disabled={!row.statCode.startsWith('S')}
                                      value = {row.statCode}
                                      onChange={async (e) => {
                                          // handleChange(row, e.target.value)
                                        recordRef.current = row
                                        statCodeRef.current = e.target.value
                                        buttonRef.current.click()
                                      }}>
                                      {
                                        statCodes.map((l, index) => (
                                          <MenuItem key={index} value={l.code} disabled={!l.code.startsWith('S')}>
                                            {l.name}
                                          </MenuItem>
                                        ))
                                      }
                                    </Select>
                                  </FormControl>
                                </TableCell>

                            ) :
                            (
                              <TableCell size='small'>{row[col.field]}</TableCell>
                            )
                          ) : null
                        ))
                      }
                    </TableRow>
                  )
                })
              }
            </TableBody>
          </MUITable>
        </DialogContent>
        <DialogActions>
          <Button variant='text' onClick={() => fetchBackward()}>
            <ArrowBackIosNewOutlinedIcon />
          </Button>
          <Button variant='text' onClick={() =>fetchForward()}>
            <ArrowForwardIosOutlinedIcon />
          </Button>
          <Button variant='outlined' onClick={handleClose}>
            닫기
          </Button>
        </DialogActions>
      </Dialog>

      {renderIndicator()}
      {renderAlert()}
    </Fragment>
  )
}

export default ManagerAttdncPartBing
